import { VList } from '@sleepstation/components-layouts'
import { renderList, toId } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { includes } from 'ramda'
import React from 'react'
import styled from 'styled-components'
import InterestsListItem from './InterestsListItem'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VList).attrs({
  spacing: 0.5,
  'data-cy': `interest-list`,
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const InterestsList = ({ interests, selectedInterests, onSelectionChange }) => (
  <Layout>
    {renderList(({ title, imageUrl, imageUrlSelected }) => {
      const isSelected = includes(title, selectedInterests)
      const id = toId(title)

      return (
        <InterestsListItem
          title={title}
          id={id}
          imageUrl={imageUrl}
          imageUrlSelected={imageUrlSelected}
          isSelected={isSelected}
          onClick={() => {
            onSelectionChange(title, { isSelected: !isSelected })
          }}
        />
      )
    }, interests)}
  </Layout>
)

InterestsList.propTypes = {
  interests: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedInterests: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectionChange: PropTypes.func.isRequired,
}

export default InterestsList
